import React from 'react';

class BreadCrumb extends React.Component {
	render() {
		const { title1, title2 } = this.props;
		return (
			<div className="right-wrapper text-right">
				<ol className="breadcrumbs">
					<li>
						<a href="/">
							<i className="fa fa-home"></i>
						</a>
					</li>
					<li><span>{title1}</span></li>
                    {(title2) ? (<li><span>{title2}</span></li>) : (null)}
				</ol>
				<a className="sidebar-right-toggle" data-open="sidebar-right"><i className="fa fa-chevron-left"></i></a>
			</div>
		)
	}
}

export default BreadCrumb;
